document.addEventListener("DOMContentLoaded", function () {
  var checkboxFactura = document.getElementById("factura-check");
  var cartAttributes = document.getElementById("cart-attributes");
  var cartAttributesInputs = cartAttributes.querySelectorAll('#cart-attributes input[type="text"]');
  var cartAttributesSelects = document.querySelectorAll('.custom-select select');
  var form = document.getElementById("cart");
  var isFormActive = false;
  var errorMissing = document.getElementById("error-missing");
  var tipoContribuyenteContainer = document.querySelector('#contribuyente-container');

  function emptyForm() {
    if (!checkboxFactura.checked) {
      console.log('Valores eliminados');
      cartAttributesInputs.forEach(function(input) {
        input.value = "";
        input.classList.remove('missing');
      });
      cartAttributesSelects.forEach(function(select) {
        select.selectedIndex = 0;
        select.classList.remove('missing');
      });
      errorMissing.classList.remove("enabled");
      tipoContribuyenteContainer.style.display = 'none';
    }
  }

  function disableForm() {
    isFormActive = false;
    cartAttributes.classList.remove("enabled");
  }

  function enableForm() {
    isFormActive = true;
    cartAttributes.classList.add("enabled");
  }

  function checkCheckbox() {
    if (checkboxFactura.checked) {
      enableForm();
    } else {
      disableForm();
    }
  }
  
  function handleSelectChange() {
    var selectedValue = this.value;
    if (selectedValue !== '') {
      this.classList.remove('missing');
    }
  }

  // Esta función maneja el evento input de los elementos input
  function handleInputChange() {
    if(this.value.trim() !== ""){
      this.classList.remove('missing');
    }
  }

  form.addEventListener("submit", function (event) {
    if (checkboxFactura.checked) {
      var areInputsFilled = Array.from(cartAttributesInputs).every(function (input) {
        return input.value.trim() !== "";
      });
  
      var areSelectsFilled = Array.from(cartAttributesSelects).every(function (select) {
        return select.value !== '';
      });
  
      if (!areInputsFilled || !areSelectsFilled) {
        event.preventDefault();
        cartAttributesInputs.forEach(function (input) {
          if (input.value.trim() === "") {
            input.classList.add("missing");
          } else {
            input.classList.remove("missing");
          }
        });
        
        cartAttributesSelects.forEach(function(select) {
          var selectedValue = select.value;
          
          if (selectedValue === '') {
            select.classList.add('missing');
          } else {
            select.classList.remove('missing');
          }
        });
  
        errorMissing.classList.add("enabled");
      }
    }
  });

  // Añade un event listener input a cada elemento input
  cartAttributesInputs.forEach(function(input) {
    input.addEventListener('input', handleInputChange);
  });

  cartAttributesSelects.forEach(function(select) {
    select.addEventListener('change', handleSelectChange);
  });

  checkboxFactura.addEventListener("change", checkCheckbox);

  checkboxFactura.addEventListener("click", emptyForm);

  checkCheckbox();

  window.addEventListener("pageshow", function (event) {
    checkCheckbox();
  });
});